module.exports = __webpack_public_path__ + "img/2001_03.b191736a.jpg";